import { useRef } from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import { useTurnAuthoritySnapshot, DEFAULT_TURN_AUTHORITY_SNAPSHOT } from './TurnAuthoritySnapshotContext'
import type { CartItemPrice, CartContextSummary } from './TurnAuthoritySnapshotContext'

interface Props {
  cartItemPrices: Array<CartItemPrice>
  summary?: CartContextSummary
}

export function CartPricingSnapshotRegistration({ cartItemPrices, summary }: Props) {
  const snapshotRef = useTurnAuthoritySnapshot()
  const owner = useRef(Symbol('surface contribution')).current

  useIsomorphicLayoutEffect(() => {
    snapshotRef.current.cartOwner = owner
    snapshotRef.current.cartItemPrices = cartItemPrices
    snapshotRef.current.cartSummary = summary
  }, [owner, snapshotRef, cartItemPrices, summary])

  // Only a runtime unmount clears canonical checkout facts.
  useIsomorphicLayoutEffect(() => () => {
    if (snapshotRef.current.cartOwner !== owner) return
    snapshotRef.current.cartSummary = undefined
    snapshotRef.current.cartOwner = undefined
    snapshotRef.current.cartItemPrices = DEFAULT_TURN_AUTHORITY_SNAPSHOT.cartItemPrices
  }, [owner, snapshotRef])

  return null
}
